<template>
	<div class="lead-table">
		<ScheduleMeetingModal :show_schedule_meeting.sync="modals.show_schedule_meeting" :leadData="leadData"
			@closeMeetingModal="closeMeetingModal" />
		<LogCallModal :log_call.sync="modals.log_call" :leadData="leadData" @closeLogCallModal="closeLogCallModal" />
		<AssignLeadsToModalVue :assign_lead.sync="modals.assign_lead" :lead_data="lead_data"
			@closeAssignToModal="closeAssignToModal" @getLeads="getListing" />
		<LeadAssignmentHistoryModal :lead_assignment_history.sync="modals.lead_assignment_history"
			:lead_data_history="lead_data_history" :lead_detail="lead_detail" ref="lead_assignment_history_ref" />
		<!-- <FilterDrawer ref="drawer_filter_lead" :agents_list="agentsList" :customer_status_list="customerSubStatusList" @filter_assign_ids="filterAssignedTo($event)" /> -->
		<b-row>
			<b-col cols="12">
				<button type="button" class="btn-icon-clipboard">
					<router-link to="/leadsCalendar">
						<div>
							<i class="ni ni-calendar-grid-58"></i>
							<span>Calendar View</span>
						</div>
					</router-link>
				</button>
			</b-col>
		</b-row>
		<b-card no-body>
			<div  v-loading="!_gHlp.isEmpty(loading_summary)" :element-loading-text="loading_summary">
			<b-card-header class="border-0">
					<b-row></b-row>
			</b-card-header>
			<b-row class="mb-4 mx-3" v-if="_gAuth.activeCorpIsMultiAssignment()">
				<b-col cols="12" class="px-0 mb-1">
					<p class="font-weight-bold text-muted">Profile Type</p>
				</b-col>
				<b-col cols="6" md="auto" class="px-1">
					<b-button block
						:variant="this.filters.profile_type == 'all' || _gHlp.isEmpty(this.filters.profile_type) ? 'primary' : 'outline-primary'"
						class="mb-2 mr-2 shadow-none" @click="selectProfileButton('all')">
						<span class="font-weight-600">All</span><br>
					</b-button>
				</b-col>
				<b-col cols="6" md="auto" class="px-1" v-if="_gHlp.checkAccess(['role_admin', 'role_corporate', 'role_super_admin', 'role_it_admin'])">
						<b-button
								block
								:variant="this.filters.profile_type == 'recycle_lead' ? 'primary' : 'outline-primary'"
								class="mb-2 mr-2 shadow-none"
								@click="selectProfileButton('recycle_lead')"
						>
								<span class="font-weight-600">Recycle Lead Listing</span><br>
						</b-button>
				</b-col>
				<b-col cols="6" md="auto" class="px-1" v-if="_gHlp.checkAccess(['role_admin', 'role_corporate', 'role_super_admin', 'role_it_admin'])">
					<b-button block :variant="this.filters.profile_type == 'master_shuffle' ? 'primary' : 'outline-primary'"
						class="mb-2 mr-2 shadow-none" @click="selectProfileButton('master_shuffle')">
						<span class="font-weight-600">Master Shuffle Lead Listing</span><br>
					</b-button>
				</b-col>
			</b-row>
				<b-row class="mb-4 mx-3">
				<b-col cols="12" class="px-1">
					<h4 class="text-primary">Main Status</h4>
				</b-col>
				<b-col cols="auto" md="auto" class="px-1" v-for="(value, key, index) in card_filters" :key="index">
					<b-button block :variant="selectedFilterButton === key ? 'primary' : 'outline-primary'"
						class="mb-2 mr-2 shadow-none" :class="[
							(['New Leads', 'Missing Status'].includes(key) ? (!checkAppCodeAndRoleType(['sas'], ['admin', 'manager', 'director', 'sales']) ? 'd-none' : '' ) : ''),
							(['New Leads', 'Missing Status'].includes(key) && value <= 0 ? 'd-none' : ''),
							(['Drop', 'Returned'].includes(key) && _gAuth.isAppSas() && _gAuth.activeUser('account_info.is_have_recyle_lead') ? 'd-none' : '')
						]" @click="selectFilterButton(key)">
						<span class="font-weight-600">{{ key }}</span><br>
						{{ value }}
					</b-button>
				</b-col>
			</b-row>
			<b-row class="mb-4 mx-3">
				<b-col cols="12" class="px-1" v-if="Object.keys(card_filters).length > 0">
					<p class="font-weight-bold text-muted">Period</p>
				</b-col>
				<b-col cols="6" md="auto" class="px-1">
					<b-button block :variant="filters.period === 'all' ? 'primary' : 'outline-primary'"
						class="mb-2 mr-2 shadow-none" @click="filterPeriod('all')">
						<span class="font-weight-600">All</span><br>
						{{ periodCounts.all }}
					</b-button>
				</b-col>
				<b-col cols="6" md="auto" class="px-1">
					<b-button block :variant="filters.period === 'today' ? 'primary' : 'outline-primary'"
						class="mb-2 mr-2 shadow-none" @click="filterPeriod('today')">
						<span class="font-weight-600">Today</span><br>
						{{ periodCounts.today }}
					</b-button>
				</b-col>
				<b-col cols="6" md="auto" class="px-1">
					<b-button block :variant="filters.period === 'yesterday' ? 'primary' : 'outline-primary'"
						class="mb-2 mr-2 shadow-none" @click="filterPeriod('yesterday')">
						<span class="font-weight-600">Yesterday</span><br>
						{{ periodCounts.yesterday }}
					</b-button>
				</b-col>
				<b-col cols="6" md="auto" class="px-1">
					<b-button block :variant="filters.period === '7_days' ? 'primary' : 'outline-primary'"
						class="mb-2 mr-2 shadow-none" @click="filterPeriod('7_days')">
						<span class="font-weight-600">7 Days</span><br>
						{{ periodCounts['7_days'] }}

					</b-button>
				</b-col>
				<b-col cols="6" md="auto" class="px-1">
					<b-button block :variant="filters.period === '30_days' ? 'primary' : 'outline-primary'"
						class="mb-2 mr-2 shadow-none" @click="filterPeriod('30_days')">
						<span class="font-weight-600">30 Days</span><br>
						{{ periodCounts['30_days'] }}
					</b-button>
				</b-col>
				<b-col cols="6" md="auto" class="px-1">
					<b-button block :variant="filters.period === 'this_week' ? 'primary' : 'outline-primary'"
						class="mb-2 mr-2 shadow-none" @click="filterPeriod('this_week')">
						<span class="font-weight-600">This Week</span><br>
						{{ periodCounts.this_week }}
					</b-button>
				</b-col>
				<b-col cols="6" md="auto" class="px-1">
					<b-button block :variant="filters.period === 'last_week' ? 'primary' : 'outline-primary'"
						class="mb-2 mr-2 shadow-none" @click="filterPeriod('last_week')">
						<span class="font-weight-600">Last Week</span><br>
						{{ periodCounts.last_week }}
					</b-button>
				</b-col>
				<b-col cols="6" md="auto" class="px-1">
					<b-button block :variant="filters.period === 'this_month' ? 'primary' : 'outline-primary'"
						class="mb-2 mr-2 shadow-none" @click="filterPeriod('this_month')">
						<span class="font-weight-600">This Month</span><br>
						{{ periodCounts.this_month }}
					</b-button>
				</b-col>
				<b-col cols="6" md="auto" class="px-1">
					<b-button block :variant="filters.period === 'last_month' ? 'primary' : 'outline-primary'"
						class="mb-2 mr-2 shadow-none" @click="filterPeriod('last_month')">
						<span class="font-weight-600">Last Month</span><br>
						{{ periodCounts.last_month }}
					</b-button>
				</b-col>
			</b-row>
			<!-- Filter Name & Status -->
			<b-row class="mb-4 mx-3" v-if="_gHlp.isEmpty(loading_summary) && _gHlp.isEmpty(loading_message)">
				<b-col cols="12" md="12" class="px-1 d-flex justify-content-between">
					<div>
						<el-button class="mx-0 mr-2" type="primary" v-if="_gHlp.checkAccess(allowAssignRoles)"
							:hidden="!showBulkAssign" @click="openModalAssignTo(selectedRows, 2)">
							Assign To
						</el-button>

						<el-button class="mx-0 mr-2" type="outline-primary"
							v-if="(_gHlp.checkAccess(allowDeleteRoles) && app_code != 'sas_v2') || _gAuth.activeUser().id === 5"
							:hidden="!showBulkAssign" @click="bulkDeleteRow(selectedRows)">
							Bulk Delete
						</el-button>

						<el-button class="mx-0 mr-2 bg-dark text-white" v-if="tableData.length > 0 && _gAuth.isCorporateOwner()"
							@click="exportLead" :loading="is_loading_export"><b-icon icon="box-arrow-left"></b-icon> Export
						</el-button>

						<el-button class="mx-0 mr-2" type="default"
							v-if="auth_user.subscription.privileges.scpk_crm_bulk_upload_leads" @click="toggleModalImportFiles">
							<b-icon icon="box-arrow-in-right"></b-icon> Import
						</el-button>

					</div>
					<div>
						<el-button type="default" v-if="checkIsCorporateSubscription()"
							@click="$refs.drawer_filter_leads.viewFilterLeads()">
							<b-icon icon="filter"></b-icon> Filter
						</el-button>
						<base-input v-else v-model="filters.filter" v-on:input="searchLeadDeboundHandler"
							prepend-icon="fas fa-search" placeholder="Search">
						</base-input>
					</div>
				</b-col>
			</b-row>
			</div>

			
			<div class="table-listings" v-loading="!_gHlp.isEmpty(loading_message)" :element-loading-text="loading_message">
				<el-table ref="multipleTable" :data="tableData" style="width: 100%" @selection-change="selectionChange">

					<!-- CHECKBOX -->
					<el-table-column v-if="_gHlp.checkAccess(allowAssignRoles)" type="selection" class-name="pb-3" width="55"
						fixed></el-table-column>

					<!-- MESSAGE BOX -->
					<el-table-column v-if="auth_user.subscription.privileges.scpk_crm_chat_massage" :fixed="isFixed" width="70"
						class-name="icons-chat">
						<template slot-scope="scope">
							<MessagingBoxButton :type="'lead'" :profile="scope.row" />
						</template>
					</el-table-column>

					<el-table-column :fixed="isFixed" class-name="icons-converted" width="50">
						<template slot-scope="scope">
							<b-icon icon="check-circle-fill" :variant="scope.row.customer ? 'success' : 'light'" font-scale="1.5"
								class="mx-2"
								v-b-tooltip.hover="scope.row.customer ? 'Converted to customer' : 'Not converted to customer'"></b-icon>
						</template>
					</el-table-column>

					<!-- NAME | ID -->
					<el-table-column label="Name/ID" label-class-name="pb-2" prop="name" min-width="260" sortable
						:fixed="isFixed">
						<template slot-scope="scope">
							<div class="d-flex align-items-center justify-content-between">
								<div>
									<h3 v-b-tooltip.hover="'Personal'" v-if="scope.row.type === 'Personal'" class="mb-0 mr-3"><b-icon
											icon="person-fill"></b-icon></h3>
									<h3 v-b-tooltip.hover="'Company'" v-else-if="scope.row.type === 'Company'" class="mb-0 mr-3"><b-icon
											icon="building"></b-icon></h3>
									<h3 v-else class="mr-4 pr-2 mb-0"></h3>
								</div>
								<div class="w-100">
									<el-tooltip effect="dark" placement="right">
										<div slot="content" class="d-flex align-items-center">
											<svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer"
												@click.prevent="copyToClipboard(scope.row.name)" width="14" height="18" viewBox="0 0 448 512">
												<path fill="currentColor"
													d="M208 0h124.1C344.8 0 357 5.1 366 14.1L433.9 82c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64v256h192v-32h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z" />
											</svg>
										</div>
										<div>
											<router-link :to="'/leadProfileDetails/' + scope.row.lead_id + '?active=overview'"
												@click="goToDetil(scope.row)" class="text-primary">
												<p class="font-weight-500 text-primary">{{ scope.row.name |
													formatUserName(20) }}</p>
											</router-link>
										</div>
									</el-tooltip>
									<!-- Clock Icon -->
									<div class="d-flex align-items-center">
										<p class="mb-0 bottom-line mr-1">{{ scope.row.lead_id }}</p>
										<ChannelPopover 
										v-if="!_gHlp.isEmpty(scope.row.parent_lead_id) && !_gHlp.isEmpty(scope.row.channel) && _gHlp.checkAccess(['role_admin', 'role_corporate', 'role_super_admin'])" 
										:lead_name="scope.row.name" 
										:lead_contact_no="scope.row.contact_no" 
										:lead_created_at="scope.row.created_at" 
										:channel_name="scope.row.channel ? scope.row.channel.name : '-'" 
										/>
									</div>
								</div>
								<div v-if="scope.row.approval_json">
									<span :class="badgeColor(scope.row.approval_json)">{{
										scope.row.approval_json.approval_status }}</span>
								</div>
							</div>
						</template>
					</el-table-column>

					<!-- BASKET COLOR -->
					<el-table-column width="55" class-name="text-center" :fixed="isFixed">
						<template slot-scope="scope">
							<svg v-if="scope.row.customer && scope.row.customer.basket"
								v-b-tooltip.hover="checkIsCorporateSubscription() ? BASKET_DESCRIPTION[scope.row.customer.basket.basket_color] : ''"
								xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="rounded"
								:style="{ 'background': BASKET_COLOR[scope.row.customer.basket.basket_color], 'padding': '0.125rem' }">
								<path fill="#fff"
									d="M21 9h-1.42l-3.712-6.496-1.736.992L17.277 9H6.723l3.146-5.504-1.737-.992L4.42 9H3a1.001 1.001 0 0 0-.965 1.263l2.799 10.264A2.005 2.005 0 0 0 6.764 22h10.473c.898 0 1.692-.605 1.93-1.475l2.799-10.263A.998.998 0 0 0 21 9zm-3.764 11v1-1H6.764L4.31 11h15.38l-2.454 9z" />
								<path fill="#fff" d="M9 13h2v5H9zm4 0h2v5h-2z" />
							</svg>
						</template>
					</el-table-column>

					<!-- CONTACT -->
					<el-table-column label="Contact" width="120">
						<template slot-scope="scope">
							<!-- Phone Icon -->
							<svg v-b-tooltip.hover="scope.row.contact_no ? scope.row.contact_no : 'N/A'"
								xmlns="http://www.w3.org/2000/svg" class="rounded-circle p-1 bg-primary" width="28" height="28"
								viewBox="0 0 24 24">
								<path fill="#fff"
									d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02c-.37-1.11-.56-2.3-.56-3.53c0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99C3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
							</svg>
							<!-- <svg xmlns="http://www.w3.org/2000/svg" class="rounded-circle p-1 bg-primary cursor-pointer" width="28" height="28" viewBox="0 0 24 24" @click="openCallModal(scope.row)"><path fill="#fff" d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02c-.37-1.11-.56-2.3-.56-3.53c0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99C3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/></svg> -->
							<!-- Mail Icon -->
							<!-- <svg v-b-tooltip.hover="scope.row.email ? scope.row.email : 'N/A'" xmlns="http://www.w3.org/2000/svg" class="rounded-circle p-1 bg-primary mx-2" width="28" height="28" viewBox="0 0 24 24"><path fill="#fff" d="M22 4H2v16h20V4zm-2 4l-8 5l-8-5V6l8 5l8-5v2z"/></svg> -->
							<!-- Calendar Icon -->
							<!-- <svg xmlns="http://www.w3.org/2000/svg" class="rounded-circle p-1 bg-primary cursor-pointer" width="28" height="28" viewBox="0 0 24 24" @click="openMeetingModal(scope.row)"><path fill="#fff" d="M11 14v-2h2v2h-2Zm-4 0v-2h2v2H7Zm8 0v-2h2v2h-2Zm-4 4v-2h2v2h-2Zm-4 0v-2h2v2H7Zm8 0v-2h2v2h-2ZM3 22V4h3V2h2v2h8V2h2v2h3v18H3Zm2-2h14V10H5v10ZM5 8h14V6H5v2Zm0 0V6v2Z"/></svg> -->
						</template>
					</el-table-column>

					<!-- NET INCOME -->
					<el-table-column min-width="180" width="auto">
						<template #header>
							<div class="d-flex flex-column">
								<div>Net Income</div>
							</div>
						</template>
						<template slot-scope="scope">
							<p class="mb-0 top-line">RM {{ (Number(scope.row.income ? scope.row.income : '0')) | moneyFormatter }}</p>
						</template>
					</el-table-column>

					<!-- SUB STATUS -->
					<el-table-column label="Sub Status" min-width="200" prop="status.current.sub.status" sortable>
						<template slot-scope="scope">
							<div
								v-if="checkIsOwnLead(scope.row) || !_gAuth.activeCorpIsMultiAssignment() || can_update_status(scope.row)"
								class="d-flex align-items-center justify-content-between">
								<div>
									<el-dropdown trigger="click" v-model="leadStatus">
										<p class="el-dropdown-link top-line">
											<span v-if="scope.row.status_detail.sub" class="d-inline-block text-truncate"
												style="max-width: 150px; overflow: unset;">{{
													scope.row.status_detail.sub.status | shortenText(20) }}</span>
											<span v-else>-</span>
											<i class="el-icon-caret-bottom el-icon--right"></i>
										</p>
										<el-dropdown-menu slot="dropdown">
											<div style="max-height: 300px;overflow-y: auto;">
												<el-dropdown-item v-for="(status, index) in subStatusList" :key="index"
													@click.native="updateLeadStatus(scope.row, status.status_id)">
													<span class="font-weight-bold">{{ status.parent_status }}</span> - {{
														status.status }}
												</el-dropdown-item>
											</div>
										</el-dropdown-menu>
									</el-dropdown>
								</div>
								<div>
									<TatDatePopover :tat_summary="scope.row.status_detail.tat_summary" />
								</div>
							</div>
							<div v-else>
								<div v-for="(item, index) in scope.row.lead_assignments"
									class="d-flex align-items-center justify-content-between">
									<p class="mb-0 top-line text-truncate">
										{{ (!_gHlp.isEmpty(item.status_detail.sub)) ? item.status_detail.sub.status : "--" }}
									</p>
									<div>
										<TatDatePopover :tat_summary="item.status_detail.tat_summary" />
									</div>
								</div>
							</div>
						</template>
					</el-table-column>

					<!-- CREATED BY -->
					<el-table-column label="Created By" width="150" prop="filter_created_by" sortable>
						<template slot-scope="scope">
							<b-avatar size="32px" v-b-tooltip.hover="scope.row.staff.name" :src="scope.row.staff.avatar_url"
								:text="_gHlp.formatInitials(scope.row.staff.name)" v-if="scope.row.staff"></b-avatar>
							<p v-else>-</p>
						</template>
					</el-table-column>

					<!-- CHANNEL | PLATFORM -->
					<el-table-column v-if="_gAuth.isAppSas() || checkAccess(['stg_channel_platform'])" label="Channel/Platform"
						min-width="200" prop="filter_channel" sortable>
						<template #header>
							<div class="d-flex flex-column">
								<div>Channel</div>
								<div>/Platform</div>
							</div>
						</template>
						<template slot-scope="scope">
							<div class="d-flex align-items-center">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
									<path fill="currentColor" d="M12 17a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z" />
								</svg>
								<p class="mb-0 top-line" v-if="scope.row.channel">{{ scope.row.channel.name }}</p>
								<p class="mb-0 top-line" v-else>—</p>
							</div>
							<div class="d-flex align-items-center">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
									<path fill="currentColor" d="M12 17a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z" />
								</svg>
								<p class="mb-0 bottom-line" v-if="scope.row.platform">{{ scope.row.platform.code }}</p>
								<p class="mb-0 bottom-line" v-else>—</p>
							</div>
						</template>
					</el-table-column>

					<!-- AGENT -->
					<el-table-column :label="checkAppCode('sas') ? 'TM' : 'Agent'" width="100" prop="filter_assign_to" sortable
						show-overflow-tooltip>
						<template slot-scope="scope">
							<div
								v-if="checkIsOwnLead(scope.row) || !_gAuth.activeCorpIsMultiAssignment() || can_update_status(scope.row)">
								<b-avatar size="32px" v-b-tooltip.hover="scope.row.assign_detail.name" :src="'#'"
									:text="_gHlp.formatInitials(scope.row.assign_detail.name)" v-if="scope.row.assign_detail"></b-avatar>
							</div>
							<div v-else>
								<b-avatar-group v-if="scope.row.lead_assignments.length > 0">
									<el-popover v-for="(item, index) in scope.row.lead_assignments" placement="top-start"
										:title="_gHlp.getValue(item, 'user_detail.name')" trigger="hover" :key="index">
										<p>
											<small class="mb-0 d-block text-success" v-if="item.user_id == scope.row.assign_to">CURRENTLY
												ASSIGNED</small>
											<small class="mb-0 d-block">Assign At : {{ item.assign_at | dateFormatString }}</small>
											<small class="mb-0 d-block">Last Message : {{ item.last_message_at | dateFormatString }}</small>
											<small class="mb-0 d-block">Last Remark : {{ item.last_remark_at | dateFormatString }}</small>
											<small class="mb-0 d-block">Date Lead Reach TAT {{ max_reasign_days }}days : {{
												calculateTATDate(item.assign_at) | dateFormatString }}</small>
											<small class="mb-0 d-block">Count down TAT : {{ calculateCountdown(item.assign_at) }}</small>
											<small class="mb-0 d-block">Criteria of Agent logo colouring based on TAT:</small>
											<span class="mb-0 d-block">1day to {{ reasign_days }}day = <span
													style="color: green;">Green</span></span>
											<span class="mb-0 d-block" v-if="(max_reasign_days > secd_reasign_days) && !_gAuth.isAppSas()">{{
												(reasign_days + 1) }}day to {{ secd_reasign_days }}day = <span
													style="color: yellow;">Yellow</span></span>
											<span class="mb-0 d-block" v-if="(max_reasign_days > secd_reasign_days) && !_gAuth.isAppSas()">{{
												(secd_reasign_days + 1) }} day to {{ max_reasign_days }}day = <span
													style="color: red;">Red</span></span>
											<span class="mb-0 d-block" v-if="(max_reasign_days <= secd_reasign_days) || _gAuth.isAppSas()">{{
												(reasign_days + 1) }} day to {{ max_reasign_days }}day = <span
													style="color: red;">Red</span></span>
										</p>
										<b-avatar slot="reference" :class="returnAgentColor(item.assign_at)"
											style="margin-left:unset !important; margin-right:unset !important; width: 32px !important; height: 32px !important;"
											:src="'#'" :text="_gHlp.formatInitials(_gHlp.getValue(item, 'user_detail.name'))">
										</b-avatar>
									</el-popover>
								</b-avatar-group>
							</div>
						</template>
					</el-table-column>

					<!-- AGENT SSA -->
					<el-table-column prop="SSA" label="SSA" width="100" v-if="_gAuth.isAppSas()">
						<template slot-scope="scope">
							<el-tooltip v-if="scope.row.customer && scope.row.customer.ssa" placement="bottom" effect="dark">
								<div slot="content">
									{{ scope.row.customer.ssa.name }}
								</div>
								<b-avatar class="cursor-pointer" size="32px" :src="scope.row.customer.ssa.avatar_url"
									:text="_gHlp.formatInitials(scope.row.customer.ssa.name)"
									@click.native="assignToModal(scope.row, true, false)"></b-avatar>
							</el-tooltip>
							<div v-else>
								<span style="font-size: 1.5rem">-</span>
							</div>
						</template>
					</el-table-column>

					<!-- CRETED DATE / TAT -->
					<el-table-column min-width="190">
						<template #header>
							<div class="d-flex flex-column">
								<div>Created Date</div>
								<div>/TAT</div>
							</div>
						</template>
						<template slot-scope="scope">
							<p class="mb-0 top-line">{{ scope.row.created_at | dateFormatString }}</p>
							<p class="mb-0 bottom-line"
								v-if="!isEmpty(scope.row.status_detail.tat_summary) && !isEmpty(scope.row.status_detail.tat_summary.tat_at)">
								<TatDatePopover :tat_summary="scope.row.status_detail.tat_summary" />
								{{ (!_gHlp.isEmpty(scope.row.status_detail.tat_summary.tat_stop_at) ?
									scope.row.status_detail.tat_summary.tat_stop_at : scope.row.status_detail.tat_summary.tat_at) |
									dateFormatString }}
							</p>
							<p v-else>-</p>
						</template>
					</el-table-column>
					<el-table-column min-width="300">
						<template #header>
							<div class="d-flex flex-column">
								<div>Appointment At</div>
							</div>
						</template>
						<template slot-scope="scope">
							<div v-if="checkIsOwnLead(scope.row) || !_gAuth.activeCorpIsMultiAssignment()"
								class="d-flex align-items-center">
								<div v-if="!_gHlp.isEmpty(scope.row.appointment_history)">
									<ApptCircleStatusPopover :lead_apt_history="scope.row.appointment_history" />
								</div>
								<div v-else>
									<div :style="'gray'" class="circle"></div>
								</div>
								<p class="mb-0 top-line mx-1">
									{{ scope.row.appointment_at | dateTimeFormatString }}
								</p>
								<i v-if="!_gHlp.isEmpty(scope.row.appointment_at)"
									@click="exportToGoogleCalendar(scope.row.appointment_at, scope.row.name)" class="el-icon-date"></i>
							</div>
							<div v-else>
								<div v-for="(item, index) in scope.row.lead_assignments" class="d-flex align-items-center">

									<div v-if="!_gHlp.isEmpty(item.appointment_history)">
										<ApptCircleStatusPopover :lead_apt_history="item.appointment_history" />
									</div>
									<div v-else>
										<div :style="{ backgroundColor: 'gray' }" class="circle"></div>
									</div>
									<p class="mb-0 top-line mx-1">
										{{ item.appointment_at | dateTimeFormatString }}
									</p>
									<i v-if="!_gHlp.isEmpty(item.appointment_at)"
										@click="exportToGoogleCalendar(item.appointment_at, scope.row.name)" class="el-icon-date"></i>
								</div>
							</div>
						</template>
					</el-table-column>

					<el-table-column fixed="right">
						<template slot-scope="scope">
							<el-dropdown trigger="click" style="cursor: pointer"
								v-if="(auth_user && _gHlp.checkAccess(allowAssignRoles)) || checkAccess(['l_lead__delete'])">
								<p class="el-dropdown-link mb-0 top-line">
									<b-icon icon="three-dots-vertical"></b-icon>
								</p>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item @click.native="openModalAssignTo(scope.row, 1)"
										v-if="(auth_user && _gHlp.checkAccess(allowAssignRoles))">Assign
										To</el-dropdown-item>
									<el-dropdown-item @click.native="openModalLeadAssignmentHistory(scope.row, scope.row)"
										v-if="(auth_user && _gHlp.checkAccess(allowAssignRoles))">Assignment
										History</el-dropdown-item>
									<el-dropdown-item @click.native="deleteRow(scope.row.lead_id)"
										v-if="checkAccess(['l_lead__delete'])">Delete</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap" v-if="_gHlp.isEmpty(loading_message)">
				<div class="d-flex align-items-center mb-3">
					<p class="card-category mb-0 text-secondary">
						Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries

						<span v-if="selectedRows.length">
							&nbsp; &nbsp; {{ selectedRows.length }} rows selected
						</span>
					</p>

					<span class="mb-0 ml-4">Rows:</span>

					<el-select class="select-primary pagination-select mx-2" v-model="pagination.perPage" placeholder="Per page"
						@change="perPageChanged">
						<el-option class="select-primary" v-for="(item, index) in pagination.perPageOptions" :key="index"
							:label="item" :value="item">
						</el-option>
					</el-select>

				</div>
				<base-pagination class="pagination-no-border" :value="pagination.currentPage"
					:perPage="pagination.perPage" :total="pagination.total" @change="paginationChanged($event)">
				</base-pagination>
			</div>
		</b-card>

		<!-- Drawer for Filter Leads -->
		<drawer-filter-leads ref="drawer_filter_leads" :subStatusList="subStatusList"
			@filter_by="filterBy($event)"></drawer-filter-leads>

		<!-- Modal Filter -->
		<modal :show.sync="modals.import_files" modalClasses="import-files-modal"
			v-if="auth_user.subscription.privileges.scpk_crm_bulk_upload_leads">
			<h6 slot="header" class="modal-title">Import Files</h6>
			<import-files-modal-content @importSuccess="importSuccess" :uploadURL="'lead/import'"
				:checkURL="'lead/import-check'"></import-files-modal-content>
		</modal>
	</div>
</template>
<script>
import { Table, TableColumn, Option, Select, Button, Dropdown, DropdownItem, DropdownMenu, Badge, Tooltip, DatePicker, Popover } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'
import DrawerFilterLeads from '@/views/Leads/LeadsListingComponents/FilterLeads'
import ImportFilesModalContent from '@/views/Leads/LeadsListingComponents/ImportFilesModalContent'
import ScheduleMeetingModal from '@/views/Leads/LeadsProfile/LeadsModals/ScheduleMeetingModal'
import LogCallModal from '@/views/Call/Modal/LogNewCallModal'
import TatDatePopover from '@/views/Widgets/TatDatePopover'
import ApptCircleStatusPopover from '@/views/Widgets/ApptCircleStatusPopover'
import { mapState, mapActions } from 'pinia'
import { cloneDeep } from 'lodash'
import {
	notifyFunctionMixin,
	axios,
	services,
	getHeader,
	debounce,
	swal,
} from '@/assets/js/httpImports.js'
import AssignLeadsToModalVue from '@/views/Leads/Modal/AssignLeadsToModal.vue'
import LeadAssignmentHistoryModal from '@/views/Leads/Modal/LeadAssignmentHistoryModal.vue'
import { useMessagingStore } from '@/stores/messagingStore'
import { useAuthStore } from '@/stores/authStore'
import { useLeadStore } from '@/stores/leadStore'
import helperFunctionMixin from '@/assets/js/helperFunctionMixin'
import { CAN_ASSIGN_ROLE_IDS } from '@/assets/js/roles.js'
import { useConfigStore } from '@/stores/configStore';
import { BASKET_COLOR } from '@/assets/js/colors.js'
import { BASKET_DESCRIPTION } from '@/assets/js/status.js'
import { CORPORATE_ID_FOLLOW_SAS_LEAD } from '@/assets/js/corporate.js'
import { useNotificationStore } from '@/stores/notificationStore'
import ChannelPopover from '@/views/Widgets/ChannelPopover'

export default {
	name: 'leads-listing-table',
	props: {
		mainStatusList: {
			type: Array
		},
		subStatusList: {
			type: Array
		}
	},
	mixins: [notifyFunctionMixin, clientPaginationMixin, helperFunctionMixin],
	components: {
		DrawerFilterLeads,
		ImportFilesModalContent,
		ScheduleMeetingModal,
		LogCallModal,
		AssignLeadsToModalVue,
		BasePagination,
		MessagingBoxButton,
		LeadAssignmentHistoryModal,
		TatDatePopover,
		ChannelPopover,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Option.name]: Option,
		[Select.name]: Select,
		[Button.name]: Button,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[Badge.name]: Badge,
		[Tooltip.name]: Tooltip,
		[Popover.name]: Popover,
		[DatePicker.name]: DatePicker,
	},
	data() {
		return {
			BASKET_DESCRIPTION: BASKET_DESCRIPTION,
			BASKET_COLOR: BASKET_COLOR,
			CORPORATE_ID_FOLLOW_SAS_LEAD: CORPORATE_ID_FOLLOW_SAS_LEAD,
			is_loading_export: false,
			CAN_ASSIGN_ROLE_IDS: CAN_ASSIGN_ROLE_IDS,
			is_table_loading: false,
			isCardFilterLoading: false,
			propsToSearch: ['name'],
			isFixed: false,
			tableData: [],
			currentPage: 1,
			mode: 'listing',
			selectedRows: [],
			searchText: '',
			searchLeadDeboundHandler: '',
			allowAssignRoles: ['role_admin', 'role_admin_support', 'role_it_admin', 'role_sales_support_manager', 'role_corporate', 'role_super_admin', 'role_manager', 'role_sales_manager', 'role_manager_admin', 'role_sales_advisor_manager', 'role_hub_manager'],
			allowDeleteRoles: ['role_admin', 'role_admin_support', 'role_it_admin', 'role_corporate', 'role_super_admin', 'role_manager'],
			statusOption: [{
				value: 'Excellent',
				label: 'Excellent'
			}, {
				value: 'Good',
				label: 'Good'
			}, {
				value: 'Fair',
				label: 'Fair'
			}, {
				value: 'Poor',
				label: 'Poor'
			}, {
				value: 'V.Poor',
				label: 'V.Poor'
			}, {
				value: 'Uncompleted',
				label: 'Uncompleted'
			}],
			sub_status: [],
			modals: {
				import_files: false,
				show_schedule_meeting: false,
				log_call: false,
				assign_lead: false,
				lead_assignment_history: false,
			},
			leadData: {},
			allLeadsData: [],
			member_list: [],
			lead_data: [],
			showBulkAssign: false,
			selectionChangeStatus: false,
			lead_data_history: {},
			filter_by_company: '',
			filter_by_personal: false,
			selectedFilterButton: 'All',
			pagination: {
				perPageOptions: [5, 10, 25, 50, 100, 500],
				perPage: 25
			},
			card_filters: [],
			lead_detail: {},
			leadStatus: "",
			leadMainStatus: "",
			current_lead_ids: [],
			selectedDates: [],
			dateRangeValue: "",
			filters: {
				date_type: '',
				lead_name: '',
				sub_status: '',
				main_status: '',
				lead_id: '',
				created_at: '',
				updated_at: '',
				channel: '',
				platform: '',
				assign_ids: '',
				contact_no: '',
				filter: '',
				type: '',
				profile_type: 'all',
				period: "today",
			},
			rawData: [],
			rawRelations: [],
			periodCounts: {
				all: 0,
				today: 0,
				yesterday: 0,
				'7_days': 0,
				'30_days': 0,
				this_week: 0,
				last_week: 0,
				this_month: 0,
				last_month: 0
			},
		}
	},
	created() {
		this.initPageFirstTime()
	},
	mounted() {
        this.setFixed();
        window.addEventListener('resize', this.setFixed);

        this.searchLeadDeboundHandler = debounce(() => {
            this.selectedFilterButton = 'All'
            this.getListing();
        }, 500);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.setFixed);
	},
	computed: {
		...mapState(useAuthStore, ['auth_user']),
		...mapState(useConfigStore, ['app_code']),
		...mapState(useLeadStore, ['listing_current_page', 'filter_query']),
		reasign_days() {
			return _gAuth.activeCorpSettings('lead_reassign_days', 20)
		},
		secd_reasign_days() {
			return this.reasign_days * 2
		},
		max_reasign_days() {
			return _gAuth.activeCorpSettings('max_lead_reassign_days', 60)
		},
		loading_message(){
			if(_gHlp.isLoading('lead_pagination') || _gHlp.isLoading('lead_relation')){
				return 'Fetch data ...'
			}else if(_gHlp.isLoading('lead_assembly')){
				return 'Optimize page ...'
			}
			return null
		},
		loading_summary(){
			if(_gHlp.isLoading('lead_summary')){
				return 'Calculate Summary ...'
			}
			return null
		}
	},
	methods: {
		...mapActions(useLeadStore, ['getPartialLeads', 'currentPageChanged', 'setFilterQuery', 'checkIsOwnLead', 'getRealStatusSummary', 'getRealAssignAt', 'getRealAppointmentAt', 'getRealAppointmentHistory', 'getRealMessageAt', 'getRealMessageBundle']),
		...mapActions(useMessagingStore, ['getProfileListMessagesSummaries']),
		...mapActions(useNotificationStore, ['createNotification', 'fetchNotificationTemplate']),

		//INIT PAGE
		getPageData(filters) {
			this.rawData = [];
			this.getPartialLeads(filters, 'paginate').then(resp => {
				this.rawData = cloneDeep(resp);
			_gHlp.removeLoading('lead_pagination')
			this.assemblyData();
			}).catch(e => {
				_gNotif.errorFunction(e)
				_gHlp.removeLoading('lead_pagination')
			});
		},
		async getRelationData(filters) {
			this.rawRelations = [];
			this.getPartialLeads(filters, 'relation').then(resp => {
				this.rawRelations = cloneDeep(resp);
			_gHlp.removeLoading('lead_relation')
			this.assemblyData();
			}).catch(e => {
				_gNotif.errorFunction(e)
				_gHlp.removeLoading('lead_relation')
			});
		},
		async getSummaryData() {
			_gHlp.setLoading('lead_summary')
			let filters = this.getFilters();
			this.getPartialLeads(filters, 'summary').then(resp => {
				const respWithoutPeriodCounts = cloneDeep(resp);
				delete respWithoutPeriodCounts.period_counts;

				this.card_filters = cloneDeep(respWithoutPeriodCounts);

				if (resp.period_counts) {
					this.periodCounts = resp.period_counts;
				}
				
				_gHlp.removeLoading('lead_summary')
				this.assemblyData();
			}).catch(e => {
				_gNotif.errorFunction(e)
				_gHlp.removeLoading('lead_summary')
			});
		},
		async assemblyData() {
			if (!_gHlp.isEmpty(this.rawData) && !_gHlp.isEmpty(this.rawRelations)) {
				//ASSEMBLY	
				let is_multi = _gAuth.activeCorpIsMultiAssignment();
				let data = _gHlp.getValue(this.rawData, 'data', []);
				let tableData = [];
				for (var i = 0; i < data.length; i++) {
					var obj = data[i];
					obj.lead_assignments = _gHlp.getValue(this.rawRelations, 'active_assignments.' + obj.lead_id, []);
					obj.deleted_assignments = _gHlp.getValue(this.rawRelations, 'deleted_assignments.' + obj.lead_id, []);

					if(is_multi){
						if (this.checkIsOwnLead(obj)) {
							obj.status_detail = this.getRealStatusSummary(obj);
							obj.message_group_bundle_key = this.getRealMessageBundle(obj);
							obj.reassignment_at = this.getRealAssignAt(obj);
							obj.last_message_at = this.getRealMessageAt(obj);
							obj.appointment_at = this.getRealAppointmentAt(obj);
							obj.appointment_history = this.getRealAppointmentHistory(obj);
						}
						// obj.recomend_assign_id = _gHlp.getValue(obj.recomeded_assign_to, '0');
						// obj.recomend_assign_agent = null;
						// obj.recomend_assign_agents = [];
						// if (!_gHlp.isEmpty(obj.recomeded_assign_to)) {
						// 	obj.recomend_assign_agent = await this.getUser(_gHlp.getValue(obj.recomeded_assign_to, '0'));
						// 	for (const id of obj.recomeded_assign_to) {
						// 		let user = await this.getUser(id);
						// 		obj.recomend_assign_agents.push({
						// 			label: user.name,
						// 			value: user.id
						// 		})
						// 	}
						// }
					}

					tableData.push(obj);
				}

				this.tableData = tableData
				this.pagination.currentPage = _gHlp.getValue(this.rawData, 'meta.current_page', 1)
				this.pagination.perPage = Number(_gHlp.getValue(this.rawData, 'meta.per_page', 50))
				this.pagination.total = _gHlp.getValue(this.rawData, 'meta.total', 0)
				this.pagination.from = _gHlp.getValue(this.rawData, 'meta.from', 1)
				this.pagination.to = _gHlp.getValue(this.rawData, 'meta.to', 50)

				this.current_lead_ids = []
				for (let i = 0; i < data.length; i++) {
					this.current_lead_ids.push(data[i].lead_id)
				}

				this.getProfileListMessagesSummaries('lead', this.tableData);
				_gHlp.removeLoading('lead_assembly')
			}
		},
		getFilters() {
			let filtered = {};
			let obj = this.filters;
			Object.keys(obj).forEach(key => {
				if (!_gHlp.isEmpty(obj[key])) {
					filtered[key] = obj[key];
				}
			});

			let pg = {
				paginate: this.pagination.perPage,
				page: this.pagination.currentPage,
				card: !_gHlp.isEmpty(this.selectedFilterButton) ? this.selectedFilterButton : 'All',
				show_period_counts: true,
			}
			filtered = { ...filtered, ...pg }
			return filtered;
		},
		setFilter(obj) {
			this.filters = { ...this.filters, ...obj }
			this.getListing(true)
		},
		getListing() {
			_gHlp.setLoading('lead_pagination')
			_gHlp.setLoading('lead_relation')
			_gHlp.setLoading('lead_assembly')
			let filters = this.getFilters();
			this.getPageData(filters);
			this.getRelationData(filters);
		},

		/* INIT PAGE FIRST TIME */
		initPageFirstTime() {
			if (Object.keys(this.filter_query).length === 0) {
				history.pushState({}, null, this.$route.path + '?page=' + this.listing_current_page)
				this.filterBy(this.filter_query);
			} else {
				this.filters = this.filter_query;
				let page = (this.$route.query.page > 0) ? this.$route.query.page : 1;
				if (!_gHlp.isEmpty(this.filters.card)) {
					this.selectedFilterButton = this.filters.card;
					delete this.filters.card;
				}
				this.paginationChanged(page);
				this.getSummaryData()
			}
		},
		can_update_status(lead) {
			let channelIds = _gAuth.activeCorpSettings('lead_reassign_only_channel_ids', []);
			const allowSasOwnOnly = (_gAuth.isAppSas() && (channelIds.includes(lead.channel_id) || lead.message == 'lead-slack') && this.checkIsOwnLead(lead));
			const allowSasAdminOnly = (_gAuth.isAppSas() && !(channelIds.includes(lead.channel_id) || lead.message == 'lead-slack') && _gHlp.checkAccess(['role_admin', 'role_admin_support', 'role_super_admin', 'role_manager_admin']));

			return this.checkIsOwnLead(lead) || (_gAuth.activeCorpIsMultiAssignment() && !_gAuth.isAppSas()) || allowSasOwnOnly || allowSasAdminOnly
		},
		badgeColor(approval) {
			switch (approval.approval_status) {
				case 'pending':
					return 'badge badge-warning';
				case 'approved':
					return 'badge badge-success';
				case 'rejected':
					return 'badge badge-danger';
				default:
					return 'badge badge-success';
			}
			return 'badge badge-success';
		},
		exportLead() {
			if (this.current_lead_ids.length === 0) {
				_gNotif.errorFunction(null, 'There are no leads to be exported')
				return false;
			}

			const url = _gAuth.isAppSas() ? 'lead/export' : 'vps/lead/export'
			this.is_loading_export = true
			axios.get(services.lead + url, {
				params: {
					lead_ids: this.current_lead_ids
				},
				headers: getHeader(),
				responseType: 'blob'
			})
				.then(res => {
					this.is_loading_export = false
					let timestamp = Math.floor(new Date().getTime() / 1000)
					let filename = 'lead_export_' + timestamp + '.xlsx';
					this.createDownloadFileLink(res.data, filename)
				})
				.catch(e => {
					this.is_loading_export = false
					_gNotif.errorFunction(e)
				})
		},
		importSuccess() {
			this.getListing()
			this.modals.import_files = false
		},
		isPageReload() {
			const perfEntries = performance.getEntriesByType('navigation');
			const lastEntry = perfEntries[perfEntries.length - 1];
			return lastEntry.type === 'reload';
		},
		selectionChange(selectedRows) {
			this.selectedRows = selectedRows
			this.showBulkAssign = (selectedRows.length > 0)
		},
		paginationChanged(page) {
			history.pushState({}, null, this.$route.path + '?page=' + encodeURIComponent(page))
			this.currentPageChanged(page)
			this.pagination.currentPage = page
			this.getListing()
		},
		perPageChanged() {
			this.pagination.currentPage = this.listing_current_page
			this.getListing()
		},
		goToDetil(item) {
			let filters = this.filters
			filters['card'] = this.selectedFilterButton
			this.setFilterParams(filters, this.pagination.currentPage)
			// this.$router.push('/leadProfileDetails/' + item.lead_id + '?active=overview');
		},
		setFixed() {
			this.isFixed = window.innerWidth > 768;
		},
		toggleModalImportFiles() {
			this.modals.import_files = !this.modals.import_files;
		},
		openMeetingModal(leadData) {
			this.leadData = leadData;
			this.modals.show_schedule_meeting = true;
		},
		openCallModal(leadData) {
			this.leadData = leadData
			this.modals.log_call = true
		},
		closeLogCallModal() {
			this.modals.log_call = false
		},
		getClockIconColor(tracking_color) {
			switch (tracking_color) {
				case 'green':
					return 'text-success'; // Change to green color class
					break;
				case 'yellow':
					return 'text-warning'; // Change to yellow color class
					break;
				case 'red':
					return 'text-danger'; // Change to red color class
					break;
				default:
					return 'text-primary'; // Change to blue color class
					break;
			}
		},
		closeMeetingModal() {
			this.modals.show_schedule_meeting = false;
		},
		openModalAssignTo(lead_data, type) {
			// type 1 = single lead, type 2 = bulk leads
			this.lead_data = []
			if (type == 1) {
				this.lead_data.push(lead_data)
				this.lead_data['assign_type'] = 1
			}
			else {
				this.lead_data.push(lead_data)
				this.lead_data['assign_type'] = 2
			}
			this.modals.assign_lead = true;
		},
		closeAssignToModal() {
			this.modals.assign_lead = false
		},
		openModalLeadAssignmentHistory(lead_data_history, lead_detail) {
			this.lead_detail = lead_detail
			this.lead_data_history = lead_data_history
			this.modals.lead_assignment_history = true
		},
		selectFilterButton(button) {
			this.pagination.currentPage = 1
			this.sub_status = []
			this.selectedFilterButton = button;
			this.getListing()
		},
		selectProfileButton(key) {
			this.filters.profile_type = key;
			this.pagination.currentPage = 1
			this.sub_status = []
			this.selectedFilterButton = '';
			this.getListing()
			this.getSummaryData()
		},
		updateLeadStatus(lead, status_id) {
			axios.put(services.lead + 'lead/' + lead.lead_id + '/status/' + status_id, {}, { headers: getHeader() })
				.then(async res => {
					this.getListing()
					this.getSummaryData()
					this.notifySuccess('<b>Lead Status: ' + lead.name + '</b> - Successfully Updated.')
					const notificationTemplate = await this.fetchNotificationTemplate('LEAD_STATUS_CHANGE')
					if (notificationTemplate) {
						let message = notificationTemplate.notif_temp_message

						const recipients = notificationTemplate.notif_temp_receiver.split(',').map(id => parseInt(id.trim(), 10));
						let contentNotification = {
							noti_message: "Lead #" + this.$route.params.lead_id + " : " + message,
							noti_url: window.location.origin + '/leadsListing',
							microservice_code: 'lead',
							noti_related_type: 'lead',
							noti_related_id: this.$route.params.lead_id
						}
						for (const recipient of recipients) {
							if (!isNaN(recipient)) { // Check if recipient is a valid integer
								let notification = { ...contentNotification, noti_user_id: recipient };

								// let notification = { ...contentNotification, noti_user_id: recipients }

								this.createNotification(notification)
							}
						}
					}
				})
				.catch(e => {
					this.errorFunction(e)
				})
		},
		filterByDate($e) {
			this.selectedDates = []
			if ($e) {
				$e.forEach(element => {
					this.selectedDates.push(element)
				});
			}
			this.getListing()
		},
		copyToClipboard(value) {
			const tempInput = document.createElement('input');
			tempInput.value = value;
			document.body.appendChild(tempInput);
			tempInput.select();
			document.execCommand('copy');
			document.body.removeChild(tempInput);

			// this.notifySuccess('<b>Customer Name:</b> Copied to Clipboard')
			this.notifySuccess('<b>Customer Name:</b> ' + value + '<br>Copied to Clipboard.')
		},
		filterBy(event) {
			if (event.date_type == 1) {
				this.filters.updated_at = ''
				this.filters.created_at = event.date_range
			} else if (event.date_type == 2) {
				this.filters.created_at = ''
				this.filters.updated_at = event.date_range
			} else {
				this.filters.created_at = ''
				this.filters.updated_at = ''
			}
			this.filters.lead_name = event.lead_name
			this.filters.lead_id = event.lead_id
			this.filters.sub_status = event.sub_status
			this.filters.assign_ids = event.assign_ids
			this.filters.channel = event.channel
			this.filters.platform = event.platform
			this.filters.contact_no = event.contact_no
			this.selectedFilterButton = 'All'
			this.pagination.currentPage = 1

			this.setFilterParams(this.filters)
			this.setFilterQuery(event)
			this.getListing()
			this.getSummaryData()
		},
		setFilterParams(queryfilters, page = 1) {
			this.currentPageChanged(page)

			let obj = {};
			let pg = { page: this.pagination.currentPage }
			if (!_gHlp.isEmpty(queryfilters)) {
				obj = Object.assign(pg, queryfilters);
			}
			let qp = _gHlp.generateQueryParams(obj);
			history.pushState({}, null, this.$route.path + '?' + qp)
		},
		deleteRow(lead_id) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					axios.delete(services.lead + 'leads/' + lead_id, { headers: getHeader() })
						.then(res => {
							this.getListing()
							this.getSummaryData()
							this.notifySuccess('<b>Lead Record: </b> - Successfully Deleted.')
							return
						})
						.catch(e => {
							this.is_table_loading = false
							this.errorFunction(e)
						})
				}
			})
		},
		bulkDeleteRow(lead_data) {
			let data = {
				lead_ids: lead_data.map(item => item.lead_id)
			}
			console.log(data)
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					axios.post(services.lead + 'lead/bulk-delete', data, { headers: getHeader() })
						.then(res => {
							this.getListing()
							this.getSummaryData()
							this.notifySuccess('<b>Lead Record: </b> - Successfully Deleted.')
							return
						})
						.catch(e => {
							this.is_table_loading = false
							this.errorFunction(e)
						})
				}
			})
		},
		calculateTATDate(value) {
			if (!value) return '';
			const date = new Date(value);
			date.setDate(date.getDate() + this.max_reasign_days);
			return date;
		},


		calculateCountdown(value) {
			if (!value) return '';
			const targetDate = new Date(value);
			targetDate.setDate(targetDate.getDate() + this.max_reasign_days);
			const currentDate = new Date(); // Get current date
			const differenceMs = targetDate.getTime() - currentDate.getTime();
			const differenceDays = Math.floor(differenceMs / (1000 * 60 * 60 * 24));
			return differenceDays;
		},

		returnAgentColor(value) {
			let reasign_days = this.reasign_days
			let max_reasign_days = this.max_reasign_days

			if (!value) return '';
			const assignDate = new Date(value);
			const currentDate = new Date();
			const differenceMs = currentDate.getTime() - assignDate.getTime();
			const differenceDays = Math.floor(differenceMs / (1000 * 60 * 60 * 24));
			let secRes = parseInt(reasign_days) * 2;

			if ((max_reasign_days <= secRes) || _gAuth.isAppSas()) {
				if (differenceDays >= parseInt(reasign_days)) {
					return 'cursor-pointer bg-danger';
				} else {
					return 'cursor-pointer bg-success';
				}
			} else {
				if (differenceDays >= parseInt(reasign_days) && differenceDays <= secRes) {
					return 'cursor-pointer bg-fintos';
				} else if (differenceDays >= (secRes + 1)) {
					return 'cursor-pointer bg-danger';
				} else {
					return 'cursor-pointer bg-success';
				}
			}
		},
		exportToGoogleCalendar(appointmentAt, leadName) {
			// Check if appointmentAt is not empty
			if (!this.isEmpty(appointmentAt)) {
				// Format the appointment date for the Google Calendar link
				const formattedDate = this.formatGoogleCalendarDate(appointmentAt);
				// Create the Google Calendar link
				const googleCalendarLink = this.generateGoogleCalendarLink(formattedDate, leadName);
				// Open the link in a new tab
				window.open(googleCalendarLink, '_blank');
			}
		},
		formatGoogleCalendarDate(appointmentAt) {
			const date = new Date(appointmentAt);
			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, '0');
			const day = date.getDate().toString().padStart(2, '0');
			const hours = date.getHours().toString().padStart(2, '0');
			const minutes = date.getMinutes().toString().padStart(2, '0');
			const seconds = date.getSeconds().toString().padStart(2, '0');

			return `${year}${month}${day}T${hours}${minutes}${seconds}`;
		},
		generateGoogleCalendarLink(formattedDate, leadName) {
			// Generate Google Calendar link with necessary details
			const googleCalendarLink = `https://www.google.com/calendar/render?action=TEMPLATE&dates=${formattedDate}/${formattedDate}&text=${leadName}&details=Your%20appointment%20description%20goes%20here.&location=Appointment%20Location&sf=true&output=xml`;

			return googleCalendarLink;
		},

		filterPeriod(period) {
			this.filters.period = period;
			this.pagination.currentPage = 1;
			
			this.filters.created_at = "";
			this.filters.updated_at = "";
			
			this.getListing();
			this.getSummaryData(false);
		},
	}
}
</script>